<div class="cdc-modal" [ngSwitch]="view">
  <!-- Declaracion por pasajero -->
  <ng-container *ngSwitchCase="'form'">
    <div class="cdc-modal__header">
      <h2 class="cdc-modal__title">
        {{ 'cdcAttestation.title' | translate }}
        <span class="cdc-modal__title--highlight">{{
          'cdcAttestation.titleHighlight' | translate
        }}</span>
      </h2>
      <button
        type="button"
        class="cdc-modal__close"
        [disabled]="!allSent"
        (click)="close()"
        aria-label="Close"
        data-testid="cdc-close"
      ></button>
    </div>
    <p class="cdc-modal__question">{{ 'cdcAttestation.question' | translate }}</p>

    <div class="cdc-modal__rows">
      <div class="cdc-row" *ngFor="let row of pageRows" data-testid="cdc-row">
        <p class="cdc-row__name">
          {{ row.passenger.firstName | titlecase }} {{ row.passenger.lastName | titlecase }}
        </p>

        <div class="cdc-row__answers">
          <div class="cdc-row__options">
            <button
              type="button"
              class="cdc-check"
              [class.cdc-check--on]="row.answer === 'YES'"
              [disabled]="row.status !== 'pending'"
              (click)="setAnswer(row, 'YES')"
              data-testid="cdc-yes"
            >
              <span class="cdc-check__box"></span>{{ 'cdcAttestation.yes' | translate }}
            </button>
            <button
              type="button"
              class="cdc-check"
              [class.cdc-check--on]="row.answer === 'NO'"
              [disabled]="row.status !== 'pending'"
              (click)="setAnswer(row, 'NO')"
              data-testid="cdc-no"
            >
              <span class="cdc-check__box"></span>{{ 'cdcAttestation.no' | translate }}
            </button>
          </div>
          <button type="button" class="cdc-row__link" (click)="showDeclaration()">
            {{ 'cdcAttestation.viewDeclaration' | translate }}
          </button>
        </div>

        <button
          type="button"
          class="cdc-check cdc-check--confirm"
          [class.cdc-check--on]="row.confirmed || row.status === 'sent'"
          [disabled]="row.status !== 'pending'"
          (click)="toggleConfirm(row)"
          data-testid="cdc-confirm"
        >
          <span class="cdc-check__box"></span>
          <span class="cdc-check__text">{{ 'cdcAttestation.confirm' | translate }}</span>
        </button>

        <button
          type="button"
          class="cdc-row__send"
          [class.cdc-row__send--sent]="row.status === 'sent'"
          [disabled]="!canSend(row)"
          (click)="send(row)"
          data-testid="cdc-send"
        >
          <ng-container [ngSwitch]="row.status">
            <span *ngSwitchCase="'sent'">{{ 'cdcAttestation.sent' | translate }}</span>
            <span *ngSwitchCase="'sending'">{{ 'cdcAttestation.sending' | translate }}</span>
            <span *ngSwitchDefault>{{ 'cdcAttestation.send' | translate }}</span>
          </ng-container>
        </button>
      </div>
    </div>

    <div class="cdc-modal__footer">
      <p>{{ 'cdcAttestation.showing' | translate : { count: pageRows.length } }}</p>
      <div class="cdc-pager" *ngIf="pages.length > 1">
        <button
          type="button"
          class="cdc-pager__arrow"
          [disabled]="page === 0"
          (click)="goToPage(page - 1)"
        >
          &#8249;
        </button>
        <button
          type="button"
          *ngFor="let p of pages"
          class="cdc-pager__page"
          [class.cdc-pager__page--active]="p === page"
          (click)="goToPage(p)"
        >
          {{ p + 1 }}
        </button>
        <button
          type="button"
          class="cdc-pager__arrow"
          [disabled]="page === pages.length - 1"
          (click)="goToPage(page + 1)"
        >
          &#8250;
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Formulario oficial del CDC -->
  <ng-container *ngSwitchCase="'qr'">
    <div class="cdc-modal__center">
      <h2 class="cdc-modal__title">{{ 'cdcAttestation.qrTitle' | translate }}</h2>
      <p class="cdc-modal__question">{{ 'cdcAttestation.qrDescription' | translate }}</p>
      <div class="cdc-modal__qr">
        <app-am-qrcode
          [qrdata]="cdcUrl"
          [width]="280"
          [errorCorrectionLevel]="'Q'"
          [margin]="4"
        ></app-am-qrcode>
      </div>
      <button
        type="button"
        class="cdc-modal__button"
        (click)="backToForm()"
        data-testid="cdc-qr-back"
      >
        {{ 'cdcAttestation.back' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- No se pudo asentar el SSR: concluir en mostrador -->
  <ng-container *ngSwitchCase="'error'">
    <div class="cdc-modal__center" data-testid="cdc-error">
      <h2 class="cdc-modal__title">{{ 'cdcAttestation.errorTitle' | translate }}</h2>
      <p class="cdc-modal__question">{{ 'cdcAttestation.errorMessage' | translate }}</p>
      <button type="button" class="cdc-modal__button" (click)="finish()" data-testid="cdc-error-ok">
        {{ 'cdcAttestation.accept' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- Toda la reserva a mostrador -->
  <ng-container *ngSwitchCase="'counter'">
    <div class="cdc-modal__center" data-testid="cdc-counter">
      <h2 class="cdc-modal__title">{{ 'cdcAttestation.counterTitle' | translate }}</h2>
      <p class="cdc-modal__question">{{ 'cdcAttestation.counterMessage' | translate }}</p>
      <button
        type="button"
        class="cdc-modal__button"
        (click)="finish()"
        data-testid="cdc-counter-ok"
      >
        {{ 'cdcAttestation.accept' | translate }}
      </button>
    </div>
  </ng-container>
</div>
